import type { ColorType } from '../types/colors';

/**
 * Sets the CSS class for the "this" color system.
 * This enables dynamic color theming using CSS custom properties.
 *
 * With Radix Colors migration, neutral is now part of the "this" system
 * and uses the --rx-gray-* scale.
 */
export function setThisClass(color: ColorType): string {
  return `this:${color}`;
}
